module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Grater-b1cbda1e797aea5cc8b1fe5cfe534436.svg";